import { render, staticRenderFns } from "./addOrgDialog.vue?vue&type=template&id=2022e491&scoped=true&"
import script from "./addOrgDialog.vue?vue&type=script&lang=js&"
export * from "./addOrgDialog.vue?vue&type=script&lang=js&"
import style0 from "./addOrgDialog.vue?vue&type=style&index=0&id=2022e491&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2022e491",
  null
  
)

export default component.exports